import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=20f3c0dc&scoped=true"
import script from "./VideoDetail.vue?vue&type=script&lang=js"
export * from "./VideoDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=20f3c0dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3c0dc",
  null
  
)

export default component.exports